import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { ForecastingDashboardContainerNew, ForecastingTabId } from './containers/forecasting-dashboard-container-new';

export const ForecastingRoutes = () => {
  return (
    <Routes>
      <Route path={`${ForecastingTabId.FORECASTS_LIST}`} element={<ForecastingDashboardContainerNew />} />
      <Route path={`${ForecastingTabId.PERFORMANCE_COMPARISON}`} element={<ForecastingDashboardContainerNew />} />
      <Route index element={<ForecastingDashboardContainerNew />} />
    </Routes>
  );
};
